class BaseGenerate {

    getFields(field : any) : string{
        return `` 
    }
  
    getCreateTable(tb : any) : string{
        return ``
    }

    export(data : any[] , relationData : any[]) : any {
        
      return ''
    }
}

export default BaseGenerate
  